import * as React from 'react';
import { InputInterface } from './Input/InputInterface';
import { InputState } from './Input/Input';

export interface AreaInputPropsInterface extends InputInterface<string> {
  cols?: number;
  rows?: number;
  showCounter?: boolean;
}

export class AreaInput extends React.Component<AreaInputPropsInterface, InputState> {
  constructor(props: AreaInputPropsInterface) {
    super(props);

    const newValue = (props.maxLength && props.value) ?
      props.value.substring(0, props.maxLength) : props.value;
    this.state = {
      value: newValue,
      stringValue: newValue,
      hasBlurred: true
    };
  }

  private input: HTMLTextAreaElement;

  public static defaultProps: AreaInputPropsInterface = {
    value: '',
    className: ['AreaInput'],
    automation: '',
    editable: true,
    borderless: false
  };

  public componentWillReceiveProps(props: AreaInputPropsInterface) {
    if (this.state.hasBlurred) {
      this.setState({
        value: this.handleFormatting(props.value),
        stringValue: this.handleFormatting(props.value),
        hasBlurred: true
      });
    }
  }

  private handleFormatting(value: string): string {
    if (this.props.formatter) {
      return this.props.formatter.render(this.props.formatter.read(value));
    }
    return value;
  }

  private handlePattern(value: string): string {
    if (!this.props.pattern) {
      return value;
    }
    if (value.match(this.props.pattern)) {
      return value;
    } else {
      return this.state.value;
    }
  }

  private handleOnBlur(e: Event) {
    this.setState({
      ...this.state,
      hasBlurred: true
    });

    if (this.props.onBlur) {
      this.props.onBlur(this.state.value, this.state.stringValue);
      (e.target as HTMLTextAreaElement).value = this.state.value;
    }
  }

  private handleOnChange(e: Event) {
    if (this.props.editable === false) {
      return;
    }

    let stringValue: string = this.handlePattern((e.target as HTMLTextAreaElement).value);
    stringValue = (this.props.maxLength && stringValue) ?
      stringValue.substring(0, this.props.maxLength) : stringValue;
    const value = this.handleFormatting(stringValue);

    this.setState({
      value,
      stringValue,
      hasBlurred: false
    });

    if (this.props.onChange) {
      this.props.onChange(value, stringValue);
    }
  }

  public render(): JSX.Element {
    const classes = ['Controlled', 'Input'];
    if (this.props.borderless) {
      classes.push('Borderless');
    }

    let label = null;
    if (this.props.label) {
      if (this.props.maxLength && this.props.showCounter) {
        const counter = this.props.maxLength ?
            '(' + this.state.value.length + '/' + this.props.maxLength + ')' : '';
        label = (
            <span className="Label">{this.props.label} <span className="counter">{counter}</span></span>
        );
      } else {
        label = (
            <span className="Label" onClick={() => {
                this.input.focus();
            }}>{this.props.label}</span>
        );
      }
      classes.push(('hasLabel'));
    }

    const baseClasses = ['Controlled', 'Input', 'AreaInput'];
    if (this.props.labelPosition && this.props.labelPosition === 'top') {
      baseClasses.push('LabelOnTop');
    }
    if (this.props.invalid) {
      baseClasses.push('invalid');
    }

    let value = '';
    if (this.props.onChange) {
      value = this.props.value;
    } else {
      value = this.state.stringValue;
    }

    return (
      <div className={baseClasses.join(' ')}>
        {label}
        <textarea
          ref={(area) => {
            this.input = area;
          }}
          className={classes.join(' ') + ' ' + this.props.className.join(' ')}
          data-automation={this.props.automation}
          disabled={this.props.disabled}
          value={value}
          onChange={this.handleOnChange.bind(this)}
          onBlur={this.handleOnBlur.bind(this)}
          onClick={this.props.onClick}
          maxLength={this.props.maxLength}
          rows={this.props.rows}
          cols={this.props.cols}
          placeholder={this.props.placeHolder}
        />
      </div>
    );
  }
}
